import { render, staticRenderFns } from "./RefundTypeStep.vue?vue&type=template&id=254e3f39&scoped=true"
import script from "./RefundTypeStep.vue?vue&type=script&lang=js"
export * from "./RefundTypeStep.vue?vue&type=script&lang=js"
import style0 from "./RefundTypeStep.vue?vue&type=style&index=0&id=254e3f39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254e3f39",
  null
  
)

/* custom blocks */
import block0 from "./RefundTypeStep.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports